import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function CareersPage() {
  const { t } = useTranslation();

  const jobs = [
    {
      title: t("careers.jobs.developer.title"),
      description: t("careers.jobs.developer.description"),
      icon: "💻",
    },
    {
      title: t("careers.jobs.marketing.title"),
      description: t("careers.jobs.marketing.description"),
      icon: "📈",
    },
    {
      title: t("careers.jobs.support.title"),
      description: t("careers.jobs.support.description"),
      icon: "🎧",
    },
  ];

  return (
    <div
      className="careers-page page-animated"
      style={{
        padding: "5rem 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* HEADER */}
      <div
        className="animate-up delay-1"
        style={{
          textAlign: "center",
          marginBottom: "4rem",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            color: "#1d2b45",
            marginBottom: "1rem",
          }}
        >
          {t("careers.title")}
        </h1>

        <p
          style={{
            fontSize: "1.15rem",
            color: "#5a6b85",
            maxWidth: "750px",
            margin: "0 auto",
            lineHeight: "1.8",
          }}
        >
          {t("careers.intro")}
        </p>
      </div>

      {/* IMAGE */}
      <div
        className="animate-zoom delay-2"
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "4rem",
        }}
      >
        <img
          src="/images/screens/carrier.png"
          alt="Career"
          className="hover-image"
          style={{
            width: "100%",
            maxWidth: "650px",
            borderRadius: "28px",
            padding: "1rem",
            background: "#fff",
            boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
          }}
        />
      </div>
      {/* JOB CARDS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "2rem",
          alignItems: "stretch",
        }}
      >
        {jobs.map((job, index) => (
          <div
            key={index}
            className={`hover-card animate-up delay-${index + 1}`}
            style={{
              background: "rgba(255,255,255,0.92)",
              borderRadius: "24px",
              padding: "2rem",
              border: "1px solid rgba(3,122,246,0.08)",
              boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
              backdropFilter: "blur(10px)",

              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",

              minHeight: "380px",
              height: "100%",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "2.5rem",
                  marginBottom: "1rem",
                }}
              >
                {job.icon}
              </div>

              <h2
                style={{
                  marginBottom: "1rem",
                  color: "#1d2b45",
                  fontSize: "1.5rem",
                }}
              >
                {job.title}
              </h2>

              <p
                style={{
                  color: "#4d5d78",
                  lineHeight: "1.8",
                  marginBottom: "2rem",
                }}
              >
                {job.description}
              </p>
            </div>

            <button
              style={{
                background: "linear-gradient(90deg, #037af6 0%, #58acfa 100%)",
                border: "none",
                color: "#fff",
                padding: "0.9rem 1.4rem",
                borderRadius: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "0.3s ease",
                width: "100%",
                fontSize: "1rem",
                marginTop: "auto",
              }}
            >
              {t("careers.jobs.apply")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CareersPage;
